var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 12"}},[_c('path',{attrs:{"d":"M8.747 4.538L2.533 1.752a.429.429 0 00-.604.392v5.785a.429.429 0 00.615.386l6.214-3a.429.429 0 00-.011-.777zM.643.857A.643.643 0 000 1.5v9a.643.643 0 101.286 0v-9A.643.643 0 00.643.857z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }